import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mode: 'develop',
    error: {
      userLogin: '',
      userValidate: {}
    },
    login: {
      step: 1,
      loading: false,
      token: window.sessionStorage.getItem('token') || '',
      role: 'admin',
      logged: window.sessionStorage.getItem('logged') || false,
    },
    drawers: {
      left: null,
      right: null
    },
    selectedGame: {},
    transactions: [],
    games: [],
    providers: [],
    selectedProvider: {},
    userData: window.sessionStorage.getItem('userData') ? JSON.parse(window.sessionStorage.getItem('userData')) : undefined
  },
  getters: {
    getNotification: state => {
      return state.notification
    },
    getTransactions: state => {
      return state.transactions
    }
  },
  mutations: {
    setUserState(state, user){
      state.userData = user;
      window.sessionStorage.setItem('userData', JSON.stringify(user));
    },
    setUserToken(state, token){
      window.sessionStorage.setItem('token', token);
      window.sessionStorage.setItem('logged', true);
      state.login.token = token;
      state.login.logged = true;
    },
    updateBalance(state, user) {
      state.userData.balance = user.balance;
    },
    setUserRole(state, role){   // TODO, DEVELOP
      state.login.role = role;
    },
    setLoginStep(state, step){
      state.login.step = step;
    },
    setLoginLoading(state, loading){
      state.login.loading = loading;
    },
    setLogout(state){
      state.login.step = 1;
      state.login.token = '';
      state.login.logged = false;

      window.sessionStorage.setItem('token', '');
      window.sessionStorage.setItem('logged', false);
      window.sessionStorage.setItem('userData', undefined);
    },
    openDrawer(state, isLeft) {
      if (isLeft) {
        state.drawers.left = !state.drawers.left; 
      } else {
        state.drawers.right = !state.drawers.right; 
      }
    },
    playGame(state, game) {
      state.selectedGame = game;
    },
    closeGame(state) {
      state.selectedGame = {};
    },
    setErrorUserLogin(state, error){
      state.error.userLogin = error;
    },
    setErrorUserValidate(state, error){
      state.error.userValidate = error;
    },
    setUserTransactions(state, transactions) {
      console.log(transactions);
      if (transactions.length) {
        state.transactions = transactions || [];
      }
    },
    setGames(state, games) {
      if (games.length) {
        state.games = games || [];
      }
    },
    setProviders(state, providers) {
      console.log(providers);
      if (providers.length) {
        state.providers = providers || [];
      }
    },
    setProvider(state, provider) {
      state.selectedProvider = provider;
    },
  },
  actions: {
    async userLogin({commit}, userdata) {
      commit('setLoginLoading', true);
      const config = userdata;
      axios
        .post(`${process.env.VUE_APP_SERVER}/login`, config)
        .then((res) => {
          commit('setUserState', res.data);
          commit('setLoginLoading', false);
          commit('setErrorUserLogin', '');
          commit('setUserToken', res.data.token);
        })
        .catch((error) => {
          commit('setLoginLoading', false);
          commit('setErrorUserLogin', error.response);
          console.log('setNotification', 'Credentials invalid');
          console.log(error);
        });
    },
    async refreshBalance({commit, state}, userdata) {
      const config = {
        headers: { Authorization: `bearer ${state.login.token}` },
      };
      axios
        .post(`${process.env.VUE_APP_SERVER}/balance`, userdata, config)
        .then((res) => {
          commit('updateBalance', res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async userRegister({commit}, userdata) {
      commit('setLoginLoading', true);
      const config = userdata;
      axios
          .post(`${process.env.VUE_APP_SERVER}/register`, config)
          .then((res) => {
            commit('setUserState', res.data);
            commit('setLoginLoading', false);
            commit('setErrorUserLogin', '');
            commit('setUserToken', res.data.token);
          })
          .catch((error) => {
            commit('setLoginLoading', false);
            commit('setErrorUserLogin', error.response);
            console.log('setNotification', 'Credentials invalid');
            console.log(error);
          });
    },
    async userDeposit({commit, state}, userdata) {
      const config = {
        headers: { Authorization: `bearer ${state.login.token}` },
      };
      axios
        .post(`${process.env.VUE_APP_SERVER}/deposit`, userdata, config)
        .then((res) => {
          commit('updateBalance', res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async userTransactions({commit, state}, userdata) {
      const config = {
        headers: { Authorization: `bearer ${state.login.token}` },
      };
      axios
        .post(`${process.env.VUE_APP_SERVER}/transactions`, userdata, config)
        .then((res) => {
          commit('setUserTransactions', res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getProviders({commit, state}) {
      const config = {
        headers: { Authorization: `bearer ${state.login.token}` },
      };
      axios
        .get(`${process.env.VUE_APP_SERVER}/providers`, config)
        .then((res) => {
          commit('setProviders', res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getGames({commit, state}, provider) {
      const config = {
        headers: { Authorization: `bearer ${state.login.token}` },
      };
      axios
        .get(`${process.env.VUE_APP_SERVER}/games/${provider}`, config)
        .then((res) => {
          commit('setGames', res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    userLogout({commit}) {
      commit('setLogout');
      commit('setUserState', {});
    },
    openDrawer({commit}, isLeft) {
      commit('openDrawer', isLeft);
    },
    playGame({commit}, game) {
      commit('playGame', game);
    },
    closeGame({commit}) {
      commit('closeGame');
    },
    clearError({commit}) {
      commit('setErrorUserLogin', '');
    },
    setProvider({commit}, provider) {
      commit('setProvider', provider); 
    }
  },
  modules: {
  }
})
